import { isMobileAllowedPage } from '~/constants/mobilePages';


export default defineNuxtRouteMiddleware((to) => {
  const { isMobileShell } = useMobileShell();

  if (!isMobileShell.value) {
    return;
  }

  if (
    !to.name ||
    /^login___..$/.test(to.name.toString()) ||
    /^index___..$/.test(to.name.toString()) ||
    /^protocol-handler___/.test(to.name.toString()) ||
    /^admin-set-password___..$/.test(to.name.toString())
  ) {
    return;
  }

  const pageName = normalizePageName(to);

  if (!pageName || !isMobileAllowedPage(pageName)) {
    return navigateTo('/');
  }
});
